'use client';

import styled from '@emotion/styled';
import { formatFullDate } from '../../../../i18n/formatFullDate';
import { Css, Iframe, Responsive, ContentWrap } from '../../../../ui';
import { IPageLayoutProps } from '../../../shared/layout/page/PageLayout';
import { IPageEntry } from '../../../../contentful/types/IPage';
import { INewsletterEntry } from '../../../../contentful/types/INewsletterEntry';

import GenericPage from '../../../app/pages/ui/GenericPage';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';
import { SocialLinks } from '../../../../components/common/social-links/SocialLinks';
import { useGetCurrentUrl } from '../../../../utils/useGetCurrentUrl';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';

export interface IProps extends IPageLayoutProps {
	page: IPageEntry;
	newsletter: INewsletterEntry;
	siteSection?: ISiteSectionEntry;
}

export default function NewsletterPage({
	page,
	newsletter,
	siteSection,
}: IProps) {
	const { title, publicationDate, linkToPublishedNewsletter } =
		newsletter.fields;

	const currentUrl = useGetCurrentUrl();

	return (
		<GenericPage
			title={title}
			backlink={PageRoutes.CorporateNewsroomNewsletters}
			page={page}
			hideHeaderImage
			siteSection={siteSection}
		>
			<ContentWrap>
				<Wrapper>
					<center>
						<Iframe
							url={linkToPublishedNewsletter}
							maxHeight={800}
							maxWidth={800}
							title={title}
						/>
					</center>

					{publicationDate && (
						<PublicationDate>{formatFullDate(publicationDate)}</PublicationDate>
					)}

					<SocialLinks variant="dark" shareLinkUrl={currentUrl} />
				</Wrapper>
			</ContentWrap>
		</GenericPage>
	);
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: ${Css.pxToRem(40)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		h5 {
			max-width: 792px;
		}
	}
`;

const PublicationDate = styled.p`
	margin-block: ${Css.pxToRem(16)};
`;
